var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_vm._v(" Debtor Notice Control ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }